import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useStoreLogin } from "./useStoreLogin";

/** Minimal above-the-fold UI for fast LCP on the Shopify OAuth return URL. */
const StoreLogin = () => {
  const params = useParams();
  const storeLogin = useStoreLogin();

  useEffect(() => {
    if (params.shop_token) {
      void storeLogin(params.shop_token);
    }
  }, [params.shop_token, storeLogin]);

  return (
    <div
      role="status"
      aria-busy="true"
      aria-live="polite"
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "1rem",
        fontFamily:
          '"Inter Variable", system-ui, -apple-system, BlinkMacSystemFont, sans-serif',
        fontSize: "1rem",
        lineHeight: 1.5,
        color: "#1a1a1a",
        backgroundColor: "#ffffff",
      }}
    >
      Signing in…
    </div>
  );
};

export default StoreLogin;
